import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

const defaultHttpOptions = {
};

export interface IRequestOptions {
  headers?: HttpHeaders;
  observe?: 'body';
  params?: HttpParams;
  reportProgress?: boolean;
  responseType?: 'json';
  withCredentials?: boolean;
  body?: any;
}

@Injectable({
  providedIn: 'root'
})
export class AppHttpClient {

  public constructor(private httpClient: HttpClient) {
  }

  public get<T>(url: string, options?: IRequestOptions): Observable<T> {
    return this.httpClient.get<T>(url, options);
  }

  public post<T>(url: string, params: object, options?: IRequestOptions): Observable<T> {
    const startTime = new Date().getTime();
    options = options ?? defaultHttpOptions;
    return this.httpClient.post<T>(url, params, options);
  }

  public put<T>(url: string, params: object, options?: IRequestOptions): Observable<T> {
    const startTime = new Date().getTime();
    options = options ?? defaultHttpOptions;
    return this.httpClient.put<T>(url, params, options);
  }

  public delete<T>(url: string, options?: IRequestOptions): Observable<T> {
    options = options ?? defaultHttpOptions;
    return this.httpClient.delete<T>(url, options);
  }

}
